import React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import "./PopularVideoCourse.scss";
import Dropdown from "react-bootstrap/Dropdown";
import PopularCourseCardB2C from "../../NewDesign/PopularCourses/PopularCourseCardB2C";
import {
  SessionKeys,
  convertMinutesToHoursAndMinutes,
  convertSecondsToMins,
  convertTimeFormat,
  getProcureInfo,
  redirectToPageUtil,
} from "../../../utils/AppUtils";
import {
  getPopularCourses,
  getPopularCoursesClear,
} from "../../../redux/courses/actions";
import ErrorSectionSidebar from "../../ErrorPage/ErrorSectionSideBar";
import PopularVideoCardB2C from "../../NewDesign/PopularVideos/PopularVideoCardB2C";
import {
  getPopularVideos,
  getPopularVideosClear,
} from "../../../redux/video/actions";
import ErrorSection from "../../ErrorPage/ErrorSection";
import CONFIG from "../../../utils/config";
import ShimmerScreen from "../../Layouts/ShimmerScreen";
import { useNavigate } from "react-router";
import useLogin from "../../../custom-hooks/useLogin";
import { useTranslation } from "react-i18next";

const PopularVideoCourse = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [popularCoursesList, setPopularCoursesList] = useState(
    CONFIG.INITIAL_PRODUCT_CARD_DATA_FOR_POPULAR_COURSES
  );
  const [popularVideosList, setPopularVideosList] = useState(
    CONFIG.INITIAL_PRODUCT_CARD_DATA_FOR_POPULAR_VIDEOS
  );
  const [isLoading, setIsLoading] = useState(true);
  // const [APIListing, setAPIListing] = useState([]);
  // const [pageNum, setPageNum] = useState(1);
  // const [coursePageNum, setCoursePageNum] = useState(1);
  // const [videoPageNum, setVideoPageNum] = useState(1);
  const [totalCourses, setTotalCourses] = useState(0);
  const [totalVideos, setTotalVideos] = useState(0);
  const [isLoaded, setIsLoaded] = useState(true);
  const [isApiCalled, setIsApiCalled] = useState(false);
  const [isVideoApiCalled, setIsVideoApiCalled] = useState(false);

  const popularCoursesRes = useSelector(
    (state) => state.courses.popularCourses
  );
  const popularVideosRes = useSelector((state) => state.video.popularVideos);

  useEffect(() => {
    getPopularCoursesAPI();
    getPopularVideosAPI();
    // return () => {
    //   dispatch(getPopularCoursesClear());
    //   dispatch(getPopularVideosClear());
    // };
  }, []);

  const getPopularCoursesAPI = () => {
    setIsLoading(true);
    setIsApiCalled(true);
    setPopularCoursesList(CONFIG.INITIAL_PRODUCT_CARD_DATA_FOR_POPULAR_COURSES);
    dispatch(
      getPopularCourses({
        module: "popularCourses",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          entity_type: "course",
          // page: coursePageNum,
        },
      })
    );
  };

  useEffect(() => {
    setPopularVideosList(CONFIG.INITIAL_PRODUCT_CARD_DATA_FOR_POPULAR_VIDEOS);
    setPopularCoursesList(CONFIG.INITIAL_PRODUCT_CARD_DATA_FOR_POPULAR_COURSES);
  }, []);

  const getPopularVideosAPI = () => {
    setIsLoaded(true);
    setIsVideoApiCalled(true);
    setPopularVideosList(CONFIG.INITIAL_PRODUCT_CARD_DATA_FOR_POPULAR_VIDEOS);
    dispatch(
      getPopularVideos({
        module: "popularVideos",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          entity_type: "video",
          // page: videoPageNum,
        },
      })
    );
  };

  // useEffect(() => {
  //   getPopularVideosAPI();
  // }, [videoPageNum]);

  // useEffect(() => {
  //   getPopularCoursesAPI();
  // }, [coursePageNum]);

  const navigateToView = (video) => {
    let paramsReq ={
      code: video?.crscd,
      source: _.lowerCase(
        video?.source
      ),
      is_paid: video?.priceInfo.isFree,
      is_home: true,
    }
    if (!_.isEmpty(video.categoryId)) {
      paramsReq.catId = video?.categoryId[0];
    }
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    // let url = `/video-view-page/${video?.product_id}/?source=${_.lowerCase(
    //   video?.source
    // )}&code=${video?.crscd}&is_paid=${video?.priceInfo.isFree}`;
    // if (!_.isEmpty(video.categoryId)) {
    //   url += `&catId=${video?.categoryId[0]}`;
    // }
    let url = `/video-view-page/${video?.product_id}/?c=${encodedUrl}`;
    navigate(url);
  };
  const { isLoggedIn } = useLogin();
  const authBroker = useSelector((state) => state.auth.authBroker);

  const [courseData, setCourseData] = useState({});

  const formatPopularCourseCardData = (popularCoursesList) => {
    let popularCoursesListArr = [];
    let records = popularCoursesList;
    if (!_.isEmpty(records)) {
      for (let item of records) {
        let tags = [];
        tags.push(item?.provider?.display_name);
        tags.push(item?.type);
        let likes = item?.module + " Modules";
        tags.push(likes);
        let duration = convertTimeFormat(item.second, true, t);
        tags.push(duration);
        let priceInfo = getProcureInfo(item.purchased_info);
        item.priceInfo = priceInfo;
        item.isLoggedIn = isLoggedIn;
        item.is_home = true;

        popularCoursesListArr.push({
          id: item?.id,
          dbId: item?.list_id,
          is_like: item?.is_like ? item?.is_like : false,
          is_bookmark: item?.is_bookmark ? item?.is_bookmark : false,
          is_wishlist: item?.is_addtowishlist,
          productType: item?.type,
          productOrigin: item?.source,
          providerLogo: item.provider?.provider_img
            ? item.provider?.provider_img
            : "",
          btnAction: () =>
            redirectToPageUtil(
              item,
              navigate,
              authBroker,
              setCourseData,
              dispatch
            ),
          descAction: {},
          bannerAction: () =>
            redirectToPageUtil(
              item,
              navigate,
              authBroker,
              setCourseData,
              dispatch
            ),
          title: item?.title,
          thumbnail: item?.thumbnail,
          tagsArray: tags,
        });
      }

      setPopularCoursesList(popularCoursesListArr);
    } else {
      setPopularCoursesList([]);
    }
  };

  const formatPopularVideosCardData = (popularVideosList) => {
    let popularVideosListArr = [];
    let records = popularVideosList;
    if (!_.isEmpty(records)) {
      for (let item of records) {
        let tags = [];
        tags.push(item?.provider?.display_name);
        tags.push(item?.type);
        tags.push(`${item.views} View${parseInt(item.views) > 1 ? "s" : ""}`);
        tags.push(convertTimeFormat(item?.second, true, t));

        let priceInfo = getProcureInfo(item.purchased_info);
        item.priceInfo = priceInfo;

        popularVideosListArr.push({
          id: item?.product_id,
          dbId: item?.list_id,
          is_like: item?.is_like ? item?.is_like : false,
          is_bookmark: item?.is_bookmark ? item?.is_bookmark : false,
          is_wishlist: item?.is_addtowishlist,
          productType: item?.type,
          productOrigin: item?.source,
          btnAction: () => navigateToView(item),
          descAction: () => navigateToView(item),
          bannerAction: () => navigateToView(item),
          title: item?.title,
          duration: convertTimeFormat(item?.second, true, t),
          thumbnail: item?.thumbnail,
          showPlayButton: true,
          tagsArray: tags,
          providerLogo: item.provider?.provider_img
            ? item.provider?.provider_img
            : "",
        });
      }
      setPopularVideosList(popularVideosListArr);
    } else {
      setPopularVideosList([]);
    }
  };

  useEffect(() => {
    if (!_.isEmpty(popularCoursesRes)) {
      if (popularCoursesRes?.status === "success") {
        let popularCoursesList = popularCoursesRes?.payload?.payload?.list;
        setTotalCourses(popularCoursesRes?.payload?.payload?.total_records);
        formatPopularCourseCardData(popularCoursesList);
        setIsLoading(false);
      } else {
        setPopularCoursesList([]);
        setIsLoading(false);
      }
    } else {
      if (isApiCalled) {
        setPopularCoursesList([]);
        setIsLoading(false);
        setIsApiCalled(false);
      }
    }
  }, [popularCoursesRes]);

  useEffect(() => {
    if (!_.isEmpty(popularVideosRes)) {
      if (popularVideosRes?.status === "success") {
        let popularVideossList = popularVideosRes?.payload?.payload?.list;
        setTotalVideos(popularVideosRes?.payload?.payload?.total_records);
        formatPopularVideosCardData(popularVideossList);
        setIsLoaded(false);
      } else {
        setPopularVideosList([]);
        setIsLoaded(false);
      }
    } else {
      if (isVideoApiCalled) {
        setPopularVideosList([]);
        setIsLoaded(false);
        setIsVideoApiCalled(false);
      }
    }
  }, [popularVideosRes]);

  const [currentVideoIndex, setCurrentVideoIndex] = useState(1);

  const goToNextVideoItem = () => {
    // setPopularVideosList(CONFIG.INITIAL_PRODUCT_CARD_DATA_FOR_POPULAR_VIDEOS);
    // setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % totalVideos);
    setCurrentVideoIndex((prevPage) => Math.min(prevPage + 1, totalPages));
    currentItems = popularVideosList.slice(indexOfFirstItem, indexOfLastItem);
  };
  const goToPreviousVideoItem = () => {
    // setCurrentVideoIndex(
    //   (prevIndex) => (prevIndex - 1 + totalVideos) % totalVideos
    // );
    setCurrentVideoIndex((prevPage) => Math.max(prevPage - 1, 1));
  };

  const [currentCourseIndex, setCurrentCourseIndex] = useState(0);
  const VideosPerPage = 4;

  const totalPages = Math.ceil(totalVideos / VideosPerPage);
  const indexOfLastItem = currentVideoIndex * VideosPerPage;
  const indexOfFirstItem = indexOfLastItem - VideosPerPage;
  var currentItems = popularVideosList.slice(indexOfFirstItem, indexOfLastItem);
  const goToNextCourseItem = () => {
    // setCurrentCourseIndex((prevPage) => Math.min(prevPage + 1, totalPages));
    // currentItems = popularCoursesList.slice(indexOfFirstItem, indexOfLastItem);
    setCurrentCourseIndex((prevPage) => (prevPage + 1) % totalCourses);
  };
  const goToPreviousCourseItem = () => {
    // setCurrentCourseIndex((prevPage) => Math.max(prevPage - 1, 1));
    setCurrentCourseIndex(
      (prevPage) => (prevPage - 1 + totalCourses) % totalCourses
    );
  };

  // Slice the items array to only include the items for the current page

  return (
    <section className="popular-video-course-section">
      <div className="container">
        <div className="row gx-xl-5">
          <div className="col-xl-7">
            <div className="video-sec">
              <h4 className="heading-poplar">Popular courses</h4>
              {popularCoursesList.length === 0 ? (
                <ErrorSection btnTitle={"Explore Courses"} />
              ) : (
                popularCoursesList.map((item, index) => {
                  if (index === currentCourseIndex) {
                    return (
                      <>
                        <PopularVideoCardB2C
                          {...item}
                          key={`course-${index + 1}`}
                          isLoading={isLoading}
                          lastKey={popularCoursesList?.length === index + 1}
                        />
                      </>
                    );
                  }
                })
              )}
            </div>
            <div className="pagnation-sec">
              <div className="count-text-pagnation">
                {isLoading ? (
                  <ShimmerScreen case="rect" width="5rem" height="1rem" />
                ) : (
                  <>
                    {totalCourses === 0 ? totalCourses : currentCourseIndex + 1} out of {totalCourses}
                  </>
                )}
              </div>
              <div className="prev-next-btns">
                <button
                  className="pagenation-btn"
                  onClick={goToPreviousCourseItem}
                  // disabled={!isLoading ? currentCourseIndex === 1 : true}
                  disabled={
                    !isLoaded
                      ? totalCourses <= 1 || currentCourseIndex === 0
                      : true
                  }
                >
                  Previous
                </button>
                <button
                  className="pagenation-btn"
                  onClick={goToNextCourseItem}
                  // disabled={
                  //   !isLoading ? currentCourseIndex === totalPages : true
                  // }
                  disabled={
                    !isLoaded
                      ? totalCourses <= 1 ||
                        currentCourseIndex === totalCourses - 1
                      : true
                  }
                >
                  Next
                </button>
              </div>
            </div>
          </div>
          <div className="col-xl-5">
            <h4 className="heading-poplar">Popular videos</h4>
            {popularVideosList.length === 0 ? (
              <ErrorSectionSidebar />
            ) : (
              currentItems.map((item, index) => {
                return (
                  <>
                    <PopularCourseCardB2C
                      {...item}
                      key={`video-${index + 1}`}
                      isLoading={isLoaded}
                      lastKey={popularVideosList?.length === index + 1}
                    />
                  </>
                );
              })
            )}

            <div className="pagnation-sec">
              <div className="count-text-pagnation">
                {isLoaded ? (
                  <ShimmerScreen case="rect" width="5rem" height="1rem" />
                ) : (
                  <>
                    {/* {currentVideoIndex} out of {totalVideos} */}
                    {totalVideos === 0 ? "0" :currentVideoIndex} out of {Math.ceil(totalVideos / 4)}
                  </>
                )}
              </div>
              <div className="prev-next-btns">
                <button
                  className="pagenation-btn"
                  onClick={goToPreviousVideoItem}
                  disabled={!isLoading ? currentVideoIndex === 1 : true}
                >
                  Previous
                </button>
                <button
                  className="pagenation-btn"
                  onClick={goToNextVideoItem}
                  disabled={!isLoaded ? currentVideoIndex === totalPages : true}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default PopularVideoCourse;
